export default class enumTypeMessageBox {
  static SUCCESS = 0;
  static ERROR = 2;
  static WARNING = 3;
  static NONE = 4;
}
